import React from "react";
import { Box, Flex, Heading } from "theme-ui";
import { colors, typography } from '../../styles/theme';

const ComingSoon = () => {
  return (
    <Flex sx={mainContainerStyles}>
      <Heading sx={typography.h1}>
        Coming soon
        <Box sx={coloredCircleStyles}></Box>
      </Heading>
    </Flex>
  );
};

const { mainContainerStyles, coloredCircleStyles } = {
  mainContainerStyles: {
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "91.5vh",
    backgroundColor: colors.secondaryGreenMain,
  },
  coloredCircleStyles: {
    ml: "0.5rem",
    width: "1.5rem",
    height: "1.5rem",
    borderRadius: "50%",
    backgroundColor: colors.primaryMain,
    display: "inline-block",
  },
};

export default ComingSoon;
